<template>
  <div>
    <div class="reset-password">
      <h3 class="reset-h3">修改登录密码</h3>
      <van-field v-model="password" type="password" label="新  密  码" placeholder="6-18位数字、字母或特殊符号" minlength="6" />
      <van-field v-model="newPassword" type="password" label="重复密码" placeholder="6-18位数字、字母或特殊符号" minlength="6" />
      <van-button type="default" class="reg-btn" @click="regForm">提交</van-button>
    </div>
    <Floating />
    <wxNoShare />
  </div>
</template>

<script>
  import { Button, Form, Field } from 'vant'
  export default {
    components: {
      [Button.name]: Button,
      [Form.name]: Form,
      [Field.name]: Field
    },
    name: 'resetPsd',
    data () {
      return {
        password: '',
        newPassword: '',
      }
    },
    methods: {
      regForm() {
        if(this.password.trim() == ''){
          this.$toast('密码不能为空')
          return
        }
        if(this.password.trim() != this.newPassword.trim()){
          this.$toast('两次密码不相同，请重新输入')
          return
        }
        if(this.password.length < 6){
          this.$toast('密码长度不能小于六位')
          return
        }
        // 提交修改密码
        this.$api.post('user/resetPassword', {password:this.password.trim(), newPassword: this.newPassword.trim()}, r=>{
          this.$toast(r.message)
          this.$router.push({name: 'security'})
        })
      }
    },
  }
</script>

<style scoped>
  .reset-password{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: fixed;
    overflow: hidden;
    padding-top:15%;
  }
  .reset-h3{
    text-align: center;
    font-weight: normal;
    font-size: 16px;
  }
  .reg-btn{
    background: #ED6B0D;
    color:#fff;
    width: 80%;
    border-radius: 25px;
    margin: 40px auto 0;
    display: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/views/users/resetPwd.vue